import React from "react";
import { useNavigate } from "react-router-dom";
import { Ticket, MapPin, FileText, UserRound } from "lucide-react";
import { useData } from "@/context/DataContext";
import { nombrePersona } from "@/components/ocio/PersonaPlan";
import { Embarque } from "@/components/ocio/Embarque";
import { usePlanes, fechaPlan, esHoy, viajesDeHoy } from "@/lib/ocio";
import { ResumenViaje } from "@/components/ocio/ResumenViaje";
import { abrirVisor } from "@/lib/visor";

export const PlanHoy = ({ p }) => (esHoy(p) ? (
  <p className="inline-block mt-2 px-3 py-1 rounded-lg bg-[#FEF3C7] text-[#92400E] font-semibold text-base" data-testid={`ocio-plan-hoy-${p.id}`}>Tienes este plan hoy{p.hora ? ` a las ${p.hora}` : ""}</p>
) : null);

// Tarjeta de Inicio: el próximo plan de Ocio y Reservas.
export const ProximoPlan = () => {
  const navigate = useNavigate();
  const { proximos, planes } = usePlanes();
  const p = proximos[0];
  const { familyMembers = [] } = useData();
  if (!p) return null;
  const viaje = viajesDeHoy(planes).find((g) => g.some((x) => x.id === p.id));
  if (viaje) return <ResumenViaje planes={viaje} testid="inicio-resumen-viaje" />;
  return (
    <section className="bg-white border border-[#E5DFD5] rounded-2xl p-5" data-testid="inicio-proximo-plan">
      <h2 className="font-heading text-lg font-bold text-[#1C2421] flex items-center gap-2"><Ticket size={20} className="text-[#3A6B56]" /> Tu próximo plan</h2>
      <button onClick={() => navigate(`/ocio?plan=${p.id}`)} className="text-left w-full mt-2" data-testid="inicio-proximo-plan-abrir">
        <p className="font-heading text-xl font-bold text-[#1C2421] leading-tight">{p.nombre}</p>
        <p className="text-base font-semibold text-[#1C2421] flex items-center gap-1.5 mt-1" data-testid="inicio-proximo-plan-persona"><UserRound size={16} className="text-[#3A6B56]" /> {nombrePersona(familyMembers, p.family_member_id)}</p>
        <p className="text-base text-[#4A5550] mt-1 first-letter:uppercase">{fechaPlan(p)}</p>
        <PlanHoy p={p} />
        <Embarque p={p} />
        {p.lugar && <p className="text-sm text-[#6E7A74] flex items-center gap-1 mt-1"><MapPin size={14} /> {p.lugar}</p>}
      </button>
      {p.documento_id && <button data-testid="inicio-proximo-plan-entrada" onClick={() => abrirVisor({ id: p.documento_id, title: p.nombre })}
        className="mt-3 inline-flex items-center gap-1.5 min-h-[44px] px-4 rounded-xl bg-[#3A6B56] text-white font-semibold"><FileText size={18} /> Ver entrada o reserva</button>}
    </section>
  );
};
